var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "appConversasPeriodo" } },
    [
      _c(
        "el-card",
        { attrs: { shadow: "hover" } },
        [
          _c("p", { staticClass: "bolder" }, [_vm._v("Filtros")]),
          _c(
            "el-row",
            { staticClass: "margin-left" },
            [
              _c(
                "el-col",
                { attrs: { xs: 12, lg: 7, xl: 7, sm: 13 } },
                [
                  _c("InputEntreDatas", {
                    attrs: {
                      placeholder: "Período",
                      calendario: _vm.calendario
                    },
                    model: {
                      value: _vm.calendario,
                      callback: function($$v) {
                        _vm.calendario = $$v
                      },
                      expression: "calendario"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 6, xl: 8, sm: 11 } },
                [
                  _c("p", [_vm._v("Status")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "multiple",
                        "collapse-tags": "collapse-tags",
                        filterable: "filterable",
                        clearable: "clearable"
                      },
                      model: {
                        value: _vm.filtro.status,
                        callback: function($$v) {
                          _vm.$set(_vm.filtro, "status", $$v)
                        },
                        expression: "filtro.status"
                      }
                    },
                    _vm._l(_vm.status, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 9, xl: 7, sm: 13 } },
                [
                  _c("p", [_vm._v("Assunto")]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "24rem" },
                      attrs: {
                        filterable: "filterable",
                        clearable: "clearable",
                        multiple: "multiple",
                        "collapse-tags": "collapse-tags"
                      },
                      model: {
                        value: _vm.filtro.assunto,
                        callback: function($$v) {
                          _vm.$set(_vm.filtro, "assunto", $$v)
                        },
                        expression: "filtro.assunto"
                      }
                    },
                    _vm._l(_vm.assuntos, function(assunto) {
                      return _c("el-option", {
                        key: assunto.value,
                        attrs: { label: assunto.label, value: assunto.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 8, xl: 6, sm: 11 } },
                [
                  _c("p", [_vm._v("Responsável")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "multiple",
                        "collapse-tags": "collapse-tags",
                        filterable: "filterable",
                        clearable: "clearable"
                      },
                      model: {
                        value: _vm.filtro.idsResponsaveis,
                        callback: function($$v) {
                          _vm.$set(_vm.filtro, "idsResponsaveis", $$v)
                        },
                        expression: "filtro.idsResponsaveis"
                      }
                    },
                    _vm._l(_vm.responsaveis, function(item) {
                      return _c("el-option", {
                        key: item.pessoa.pessoaFisica.id,
                        attrs: {
                          label: item.pessoa.pessoaFisica.nome,
                          value: item.pessoa.pessoaFisica.id
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "margin float" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text", size: "medium", round: "round" },
                  on: { click: _vm.handleLimpar }
                },
                [_vm._v("Limpar")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "medium", round: "round" },
                  on: { click: _vm.handleFiltrar }
                },
                [_vm._v("Filtrar")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "content-dados" },
        [
          _c(
            "el-tabs",
            {
              attrs: { type: "border-card" },
              on: { "tab-click": _vm.tabSelecionado },
              model: {
                value: _vm.activeTab,
                callback: function($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab"
              }
            },
            _vm._l(_vm.tabsPeriodos, function(item) {
              return _c(
                "el-tab-pane",
                {
                  key: item.name,
                  attrs: { label: item.label, name: item.name }
                },
                [
                  _vm.activeTab === item.name && _vm.acaoCondicao
                    ? _c(item.grafico, {
                        tag: "component",
                        attrs: { dadosLabels: item.dados }
                      })
                    : _vm._e(),
                  _vm.activeTab === item.name && !_vm.acaoCondicao
                    ? _c(item.tabela, {
                        tag: "component",
                        attrs: {
                          data: item.dados,
                          colunaChave: _vm.nomeColuna,
                          totalDeConversas: item.totalDeConversas,
                          emptyData: "Não há dados registrados"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            1
          ),
          _c(
            "el-row",
            [
              _c("BotaoSelecionar", {
                staticClass: "center",
                attrs: { botao0: "Gráficos", botao1: "Tabela" },
                on: {
                  "btn-0": function($event) {
                    return _vm.selecionar("acao-1")
                  },
                  "btn-1": function($event) {
                    return _vm.selecionar("acao-2")
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "botaoExportar float" },
            [
              _c("BotaoExportarSelecionado", {
                attrs: {
                  filtro: _vm.filtro,
                  selecionadoCondicao: _vm.acaoCondicao,
                  disabled: _vm.botaoExportarDesligado,
                  dadosFiltro: _vm.filtro,
                  tab: _vm.periodo,
                  carregando: _vm.isLoading
                },
                on: { "exportar-img-grafico": _vm.exportarImgGrafico }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3167afe0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3167afe0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios_ouvidoria/components/conversas/AppConversasPeriodo.vue
// module id = null
// module chunks = 